﻿/**
  * *********************************************************************
  *                              Navigation                             *
  * *********************************************************************
  */
let navigationMessage: WebPortal.Navigation.NavigationMessage;
let navigationUtils: WebPortal.Navigation.NavigationUtils;
let notificationCenter: WebPortal.Dialog.Modal.NotificationCenter;
let notification: WebPortal.Dialog.Modal.Notification;

namespace WebPortal.Navigation {
    export const LogoffTitle = "RMS Log off Process";
    export const LogoffMessage = "Your instance has been successfully unsubscribed from RMS. You can close this tab.";

    export interface INavigationController {
        expand(withContentOffset: boolean): void;
        collapse(withContentOffset: boolean): void;
        pinNav(NavExpandedInSettingsIsSet: boolean): void;
    }

    export class NavigationController implements INavigationController {
        private navCollapsed = false; // true = Navigation eingeklappt
        private navPinned = false;
        private autoCollapsed = false;
        private docWidth = 0;

        constructor() {
            navigationUtils = new NavigationUtils();
            navigationMessage = new NavigationMessage();
        }

        get isNavCollapsed(): boolean { return this.navCollapsed; }
        get isNavAutoCollapsed(): boolean { return this.autoCollapsed; }
        get isNavPinned(): boolean { return this.navPinned; }

        /**
         * Expands the navigation bar
         * @params {boolean} withContentOffset
         * - indicates if the content should be next to the navigation bar (true) or the navigation should overlay (false)
         * @returns {void}
         */

        public expand(withContentOffset: boolean = false): void {
            let controls: JQuery = $("#pn_controls");
            let content: JQuery = $("#pn_content");
            let navState: JQuery = $("#hdf_navstate");
            let collapseMainNav: JQuery = $("#collapse-main-nav");

            // content und Hidden-Field auf expanded stellen
            $(content).removeClass("collapsed").addClass("expanded");
            if (navState) {
                $(navState).val("expanded");
            } else {
                $("#hdf_navstate").val("expanded");
            }

            // menü-Elemente und Title verstecken
            $("span.nav-element").show();
            $(collapseMainNav).parents().find(".title").show();

            // menü collapse Icon wechseln
            $("#scm_logo").show();
            $(collapseMainNav).removeClass("icon-015-chevron-right").addClass("icon-014-chevron-left");

            // Logo Schriftzug anzeigen
            $(controls).removeClass("collapsed-nav").removeClass("collapsed-nav-scroll").addClass("expanded-nav");

            $("#pn_controls li").each((index: number, elem: any) => {
                $(elem).removeAttr("title");
            });

            // badge ausrichten
            $("span.badge.badge-custom").each((index: number, elem: any) => {
                $(elem).addClass("badge-custom-expanded");
            });

            this.navCollapsed = false;

            // navigationsstatusinfo neu positionieren
            this.repositionStatusMessage(this.navCollapsed);
        }

        /**
         * Collapses the navigation bar
         * @params {boolean} withContentOffset
         * - indicates if the content should be next to the navigation bar (true) or the navigation should overlay (false)
         * @returns {void}
         */
        public collapse(withContentOffset: boolean = false): void {
            let controls: JQuery = $("#pn_controls");
            let content: JQuery = $("#pn_content");
            let navState: JQuery = $("#hdf_navstate");
            let collapseMainNav: JQuery = $("#collapse-main-nav");

            // content und Hidden-Field auf collapsed stellen
            $(content).removeClass("expanded").addClass("collapsed");

            if (navState) {
                $(navState).val("collapsed");
            } else {
                $("#hdf_navstate").val("collapsed");
            }

            // menü-Elemente und Title verstecken
            $("span.nav-element").hide();
            $(collapseMainNav).parents().find(".title").hide();

            // Logo Schriftzug verstecken und Icon wechseln
            $("#scm_logo").hide();
            $(collapseMainNav).removeClass("icon-014-chevron-left").addClass("icon-015-chevron-right");

            // menü einfahren
            $(controls).removeClass("expanded-nav").addClass("collapsed-nav");

            // glyphicons vergrössern und Text als Hint anzeigen
            $("#pn_controls li").each((index: number, elem: any) => {
                $(elem).attr("title", $(elem).children().children(".nav-element").text());
            });

            // badge ausrichten
            $("span.badge.badge-custom.badge-custom-expanded").each((index: number, elem: any) => {
                $(elem).removeClass("badge-custom-expanded");
            });

            // Prüfe ob Scrollbar aktiviert werden muss
            this.handleScroll();

            this.navCollapsed = true;

            // navigationsstatusinfo neu positionieren
            this.repositionStatusMessage(this.navCollapsed);
        }

        /**
         * Fixes the navigation bar with the current state (collapsed or expanded)
         * @params {boolean} NavExpandedInSettingsIsSet - tells if the navigation bar should be expanded by default
         * @returns {void}
         */
        public pinNav(): void;
        public pinNav(NavExpandedInSettingsIsSet: boolean): void;
        public pinNav(NavExpandedInSettingsIsSet: boolean = false): void {
            let request_param: string = $("#hdf_se_request_param").val();
            if (!!request_param) {
                if (this.navPinned) {
                    this.navPinned = false;

                    // navigation fixieren
                    if ($("#pin-main-nav").hasClass("nav-toggle-activated")) {
                        $("#pin-main-nav").removeClass("nav-toggle-activated");
                    }

                    if ($("#collapse-main-nav").css("cursor") === "not-allowed") {
                        $("#collapse-main-nav").css({ "cursor": "pointer" });
                    }
                } else {
                    this.navPinned = true;

                    // fixierung aufheben
                    if (!$("#pin-main-nav").hasClass("nav-toggle-activated")) {
                        $("#pin-main-nav").addClass("nav-toggle-activated");
                    }

                    if ($("#collapse-main-nav").css("cursor") === "pointer") {
                        $("#collapse-main-nav").css({ "cursor": "not-allowed" });
                    }

                    // expand the nav bar
                    if (NavExpandedInSettingsIsSet) {
                        this.expand(NavExpandedInSettingsIsSet);
                        return;
                    }

                    if (this.navCollapsed) {
                        this.collapse(true);
                    } else {
                        this.expand(true);
                    }
                }
                let newSettings: any = { "NavExpanded": (this.navPinned ? 1 : 0) };
                WebPortalHubObj.server.doSaveMySettings(request_param, newSettings);
            }
        }

        private repositionStatusMessage(navCollapsed: boolean): void {
            let leftPos: number = navCollapsed ? 55 : 300;

            $("[id^=pn_nav_status_info]").css({
                "left": leftPos + 10
            });
        }

        // handles responsiveness of navigation and content
        public resize(): void {
            this.docWidth = $("body").innerWidth();

            // trigger Navigation Resize on window resize
            if (!this.navPinned) {
                if (this.docWidth < 1000) {
                    if (!this.navCollapsed) {
                        this.collapse();
                        this.autoCollapsed = true;
                    }
                } else {
                    if (this.autoCollapsed) {
                        if (this.navCollapsed) {
                            this.expand();
                        }
                    }
                    this.autoCollapsed = false;
                }
            }

            this.handleScroll();
        }

        /**
         * Navigation je nach Höhenverhältnis für den Scrollbar etwas breiter machen
         */
        public handleScroll() {
            let navState: JQuery = $("#hdf_navstate");
            let sidebarHeadHeight = $("#sidebar_head").height();
            let sidebarBodyHeight = $("#sidebar_body").height();
            // Zu der Footerhöhe werden 25px fürs Margin dazugezählt und 10px fürs verhindern der Buttonüberschneidung (Margin nach dem letzten Button)
            // Main.less - Die 25px werden für die Berechnung in der Navigation auch verwendet (Beidseitige Anpassung nötig)
            let sidebarFooterHeight = $("#ul_footer").height() + 25 + 10;
            let panelControlsHeight = $("#pn_controls").height();

            let relativeFactor = panelControlsHeight - (sidebarHeadHeight + sidebarBodyHeight + sidebarFooterHeight);

            // Brauchen die Buttons mehr Platz, als verfügbar ist, wird der Modus umgeschalten und alle Buttons zusammengeführt
            if (relativeFactor < 0) {
                if (navState.val() == "collapsed") {
                    $("#pn_controls").addClass("collapsed-nav-scroll");
                    $("#pn_content").addClass("collapsed-scroll");
                }
                $("#sidebar_footer > ul").css("position", "relative");
            } else {
                if (navState.val() == "collapsed") {
                    $("#pn_controls").removeClass("collapsed-nav-scroll");
                    $("#pn_content").removeClass("collapsed-scroll");
                }
                $("#sidebar_footer > ul").css("position", "absolute");
            }
        }

        /**
         * Shows / Hides the main navigation
         * @returns {void}
         */
        public toggleNav(): void {
            if (!this.navPinned) {
                if (this.navCollapsed) {
                    this.expand();
                } else {
                    this.collapse();
                }
            }
        }
    }

    export abstract class NavigationHandler {
        constructor() { this.initNavigationHandler(); }

        private initNavigationHandler(): void {
            // session Join initialisieren
            let newTab: boolean = true;
            new WebPortal.Dialog.Modal.Session.Join(newTab);

            // navigation Toggles setzen
            $(window).on("resize", () => { navigationController.resize(); });
            $("#collapse-main-nav").off().on("click", () => { navigationController.toggleNav(); });
            $("#pin-main-nav").off().on("click", () => { navigationController.pinNav(); });

            // feedback Handler setzen
            $("#lbt_feedback").off().on("click", () => {
                $("#pn_feedback_popup").modal({ backdrop: "static", keyboard: false });
                return false;
            });

            // send Feedback Handler setzen
            $("#bt_feedback_send").off().on("click", () => {
                return this.SendFeedback();
            }).on('keyup', (e: JQueryEventObject) => {
                let ev: any = e || event;
                if (ev.keyCode === 13) {
                    return this.SendFeedback();
                }
            });

            // start Tour Handler setzen
            $("#navigation_li_starttour").off().on("click", () => {
                navigationHandler.RestartTour();
                return false;
            });

            // kontakt und Rechtliches Handler setzen
            $("#lbt_contact_and_legal").off().on("click", () => {
                let UserSettings = JSON.parse($("#hdf_settings").val());
                if (!!UserSettings && !UserSettings.IsSwisscomUser) {
                    $("#pn_contact_and_legal_contact_coc_remas_title").addClass("hidden");
                    $("#pn_contact_and_legal_contact_coc_remas").addClass("hidden");
                    $("#pn_contact_and_legal_contact_swisscom_title").removeClass("hidden");
                    $("#pn_contact_and_legal_contact_swisscom").removeClass("hidden");
                }

                console.info("check UserSettings.Language_ID");
                if (!!UserSettings && !!UserSettings.Language_ID) {
                    console.info("found UserSettings.Language_ID");
                    const tenantId = localStorage.getItem("TenantId");
                    const isTenantSwisscom = tenantId === "2";
                    $("#pn_contact_and_legal_privacy_german").addClass("hidden");
                    $("#pn_contact_and_legal_privacy_french").addClass("hidden");
                    $("#pn_contact_and_legal_privacy_italian").addClass("hidden");
                    $("#pn_contact_and_legal_privacy_english").addClass("hidden");
                    $("#pn_contact_and_legal_privacy_german_non_swisscom").addClass("hidden");
                    $("#pn_contact_and_legal_privacy_french_non_swisscom").addClass("hidden");
                    $("#pn_contact_and_legal_privacy_italian_non_swisscom").addClass("hidden");
                    $("#pn_contact_and_legal_privacy_english_non_swisscom").addClass("hidden");

                    switch (UserSettings.Language_ID) {
                        // Deutsch
                        case 2:
                            isTenantSwisscom ? $("#pn_contact_and_legal_privacy_german").removeClass("hidden") : 
                                $("#pn_contact_and_legal_privacy_german_non_swisscom").removeClass("hidden");
                            break;
                        // Französisch
                        case 3:
                            isTenantSwisscom ? $("#pn_contact_and_legal_privacy_french").removeClass("hidden") :
                                $("#pn_contact_and_legal_privacy_french_non_swisscom").removeClass("hidden");
                            break;
                        // Italienisch
                        case 5:
                            isTenantSwisscom ? $("#pn_contact_and_legal_privacy_italian").removeClass("hidden") :
                                $("#pn_contact_and_legal_privacy_italian_non_swisscom").removeClass("hidden");
                            break;
                        // alle anderen Englisch
                        default:
                            isTenantSwisscom ? $("#pn_contact_and_legal_privacy_english").removeClass("hidden") :
                                $("#pn_contact_and_legal_privacy_english_non_swisscom").removeClass("hidden");
                    }
                }

                $("#pn_contact_and_legal_popup").modal({ backdrop: "static", keyboard: false });
                return false;
            });

            // message Handler setzen
            notificationCenter = new WebPortal.Dialog.Modal.NotificationCenter();
            notification = new WebPortal.Dialog.Modal.Notification();

            // überlappt automatisch das neue Modal mit dem alten Modal
            $(document).on("show.bs.modal", ".modal", (e: JQueryEventObject) => {
                let zIndex: number = 1040 + (10 * $(".modal:visible").length);
                $(e.currentTarget).css("z-index", zIndex);
                setTimeout(() => {
                    $(".modal-backdrop").not(".modal-stack").css("z-index", zIndex - 1).addClass("modal-stack");
                }, 0);
            });
        }

        private SendFeedback(): boolean {
            $("#pn_feedback_popup").modal("hide");

            let requestParam: string = $("#hdf_se_request_param").val();
            let Message: string = $("#ta_feedback_text").val();

            if ($("#cb_feedback_addlogdata").prop("checked") === true) {
                Message += "\n\n\RMS Log Data\n";
                Message += ConsoleStore.join("\n\n")
            }

            if (!!requestParam && !!Message) {
                WebPortalHubObj.server.doSendMailToTeamMailbox(requestParam, MailType.feedback, Message);
            } else {
                console.error("Feedback Popup - Parameter Error!");
            }
            return false;
        }

        public CloseAndLogoff(_ShowLogoffMessage: boolean = true): boolean {
            ActualPage.PageUnLoad();

            if (_ShowLogoffMessage) {
                setTimeout(() => {
                    Show_Status_Message_Cause(LogoffTitle, LogoffMessage);
                }, 500);
            }

            close();
            return false;
        }

        public CloseAllWindowAndLogoff(_ShowLogoffMessage: boolean = true): boolean {
            if (WebPortal.Misc.isRmsClient()) {
                const rmsWindow: any = window;
                const ipcRenderer = rmsWindow.rms.ipcRenderer;
                ipcRenderer.send('rms-win-close-all');
            } else {
                let openWindows: Array<Window> = WebPortal.Misc.getOpenWindows();
                openWindows.forEach(openWindow => {
                    openWindow.close();
                });

                ActualPage.PageUnLoad();
                PageMethods.DoFinalizeServerSession();

                if (_ShowLogoffMessage) {
                    setTimeout(() => {
                        Show_Status_Message_Cause(LogoffTitle, LogoffMessage);
                    }, 500);
                }

                close();
            }

            return false;
        }

        public abstract StartTour(): void;
        public abstract RestartTour(): void;
    }
}